import { lastValueFrom } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import { ProductModel } from '@/models';
import ApiBase from './ApiBase';

export default class WishListService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/wishlist');

  /**
   * Get all products in wishList
   * @param {string} storeId: current storeId
   * @return {Observable}
   */
  get(storeId: string): Promise<ProductModel[]> {
    return lastValueFrom(this.api.getJSON(`${WishListService.baseUrl}/${storeId}`));
  }

  /**
   * Add product to wishList
   * @param {string} partnumber: partnumber of product to add to wishList
   * @return {Observable}
   */
  addToWishList(partnumber: string) {
    return this.api.postJSON(WishListService.baseUrl, partnumber, { noJsonHeader: true });
  }

  /**
   * Remove product from wishList
   * @param {string} partnumber: partnumber of product to remove from wishList
   * @return {Observable}
   */
  removeFromWishList(partnumber: string) {
    return this.api.deleteJSON(WishListService.baseUrl, partnumber, { noJsonHeader: true });
  }
}
